import { render } from "./prepaid-packages.view.vue?vue&type=template&id=014cf8e1&ts=true"
import script from "./prepaid-packages.view.vue?vue&type=script&lang=ts"
export * from "./prepaid-packages.view.vue?vue&type=script&lang=ts"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__